import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { ShopAddressFragmentDoc } from './shop-user.gql.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopSubscriberAgreementFragment = { __typename: 'ShopSubscriberAgreementObject', id: number, name: string, label?: string | null | undefined, termsUrls?: string | null | undefined, agreed?: boolean | null | undefined };

export type ShopSubscriberAgreementDeclarationFragment = { __typename: 'ShopSubscriberAgreementDeclarationObject', id: number, name: string, label?: string | null | undefined, termsUrls?: string | null | undefined, agreed: boolean };

export type ShopSubscriberFragment = { __typename: 'ShopSubscriberObject', id: number, state: Types.SubscriberState, locale: string, subscriptionId: number, subscriptionName: string, subscriptionSlug: string, variantId: number, variantName: string, variantInterval: Types.SubscriptionRunInterval, variantChannel: string, requirements?: { __typename: 'SubscriberRequirementsObject', canSubscribe: boolean, requirements: Array<{ __typename: 'SubscriberRequirementObject', message: string, isValid: boolean, code: string }> } | null | undefined, price?: { __typename: 'ShopCurrencyObject', amount: number, currency: string } | null | undefined, shippingAddress?: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined } | null | undefined, billingAddress?: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined } | null | undefined, userPaymentMethod?: { __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState } | null | undefined, requiredAgreements: Array<{ __typename: 'ShopSubscriberAgreementObject', id: number, name: string, label?: string | null | undefined, termsUrls?: string | null | undefined, agreed?: boolean | null | undefined }> };

export type ShopSubscriberRequirementFragment = { __typename: 'SubscriberRequirementObject', message: string, isValid: boolean, code: string };

export type ShopSubscriberQueryVariables = Types.Exact<{
  subscriberId: Types.Scalars['Int']['input'];
}>;


export type ShopSubscriberQuery = { __typename: 'Query', shopSubscriber: { __typename: 'ShopSubscriberObject', id: number, state: Types.SubscriberState, locale: string, subscriptionId: number, subscriptionName: string, subscriptionSlug: string, variantId: number, variantName: string, variantInterval: Types.SubscriptionRunInterval, variantChannel: string, requirements?: { __typename: 'SubscriberRequirementsObject', canSubscribe: boolean, requirements: Array<{ __typename: 'SubscriberRequirementObject', message: string, isValid: boolean, code: string }> } | null | undefined, price?: { __typename: 'ShopCurrencyObject', amount: number, currency: string } | null | undefined, shippingAddress?: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined } | null | undefined, billingAddress?: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined } | null | undefined, userPaymentMethod?: { __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState } | null | undefined, requiredAgreements: Array<{ __typename: 'ShopSubscriberAgreementObject', id: number, name: string, label?: string | null | undefined, termsUrls?: string | null | undefined, agreed?: boolean | null | undefined }> } };

export type ShopSubscribersQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
  channelCode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  subscriptionId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ShopSubscribersQuery = { __typename: 'Query', shopSubscribers: Array<{ __typename: 'ShopSubscriberObject', id: number, state: Types.SubscriberState, locale: string, subscriptionId: number, subscriptionName: string, subscriptionSlug: string, variantId: number, variantName: string, variantInterval: Types.SubscriptionRunInterval, variantChannel: string, requirements?: { __typename: 'SubscriberRequirementsObject', canSubscribe: boolean, requirements: Array<{ __typename: 'SubscriberRequirementObject', message: string, isValid: boolean, code: string }> } | null | undefined, price?: { __typename: 'ShopCurrencyObject', amount: number, currency: string } | null | undefined, shippingAddress?: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined } | null | undefined, billingAddress?: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined } | null | undefined, userPaymentMethod?: { __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState } | null | undefined, requiredAgreements: Array<{ __typename: 'ShopSubscriberAgreementObject', id: number, name: string, label?: string | null | undefined, termsUrls?: string | null | undefined, agreed?: boolean | null | undefined }> }> };

export type ShopCreateSubscriberMutationVariables = Types.Exact<{
  input: Types.ShopCreateSubscriberInput;
}>;


export type ShopCreateSubscriberMutation = { __typename: 'Mutation', shopCreateSubscriber: { __typename: 'ShopSubscriberObject', id: number } };

export type ShopUpdateSubscriberPaymentMethodMutationVariables = Types.Exact<{
  input: Types.ShopUpdateSubscriberPaymentMethodInput;
}>;


export type ShopUpdateSubscriberPaymentMethodMutation = { __typename: 'Mutation', shopUpdateSubscriberPaymentMethod: { __typename: 'ShopSubscriberObject', id: number } };

export type ShopUpdateSubscriberAddressMutationVariables = Types.Exact<{
  input: Types.ShopUpdateSubscriberAddressInput;
}>;


export type ShopUpdateSubscriberAddressMutation = { __typename: 'Mutation', shopUpdateSubscriberAddress: { __typename: 'ShopSubscriberObject', id: number } };

export type ShopActivateSubscriberMutationVariables = Types.Exact<{
  input: Types.ShopActivateSubscriberInput;
}>;


export type ShopActivateSubscriberMutation = { __typename: 'Mutation', shopActivateSubscriber: { __typename: 'ShopSubscriberObject', id: number, state: Types.SubscriberState, locale: string, subscriptionId: number, subscriptionName: string, subscriptionSlug: string, variantId: number, variantName: string, variantInterval: Types.SubscriptionRunInterval, variantChannel: string, requirements?: { __typename: 'SubscriberRequirementsObject', canSubscribe: boolean, requirements: Array<{ __typename: 'SubscriberRequirementObject', message: string, isValid: boolean, code: string }> } | null | undefined, price?: { __typename: 'ShopCurrencyObject', amount: number, currency: string } | null | undefined, shippingAddress?: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined } | null | undefined, billingAddress?: { __typename: 'ShopAddressObject', id: number, type: Types.AddressType, alias?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phoneNumber?: string | null | undefined, street?: string | null | undefined, complex?: string | null | undefined, suburb?: string | null | undefined, city?: string | null | undefined, businessName?: string | null | undefined, postalCode?: string | null | undefined, province?: string | null | undefined, country: string, instructions?: string | null | undefined, hash: string, coordinates?: any | null | undefined, isDefaultShippingAddress?: boolean | null | undefined, isDefaultBillingAddress?: boolean | null | undefined, recipientHash?: string | null | undefined } | null | undefined, userPaymentMethod?: { __typename: 'ShopUserPaymentMethodObject', id: number, activatedAt?: any | null | undefined, expiresAt?: any | null | undefined, description: string, publicAttributes?: any | null | undefined, isExpired: boolean, state: Types.UserPaymentMethodState } | null | undefined, requiredAgreements: Array<{ __typename: 'ShopSubscriberAgreementObject', id: number, name: string, label?: string | null | undefined, termsUrls?: string | null | undefined, agreed?: boolean | null | undefined }> } };

export type ShopPauseSubscriberMutationVariables = Types.Exact<{
  input: Types.ShopPauseSubscriberInput;
}>;


export type ShopPauseSubscriberMutation = { __typename: 'Mutation', shopPauseSubscriber: { __typename: 'ShopSubscriberObject', id: number } };

export type ShopSubscriberDeclarationMutationVariables = Types.Exact<{
  input: Types.ShopSubscriberDeclarationInput;
}>;


export type ShopSubscriberDeclarationMutation = { __typename: 'Mutation', shopSubscriberDeclaration: Array<{ __typename: 'ShopSubscriberAgreementDeclarationObject', id: number, name: string, label?: string | null | undefined, termsUrls?: string | null | undefined, agreed: boolean }> };

export const ShopSubscriberAgreementDeclarationFragmentDoc = gql`
    fragment ShopSubscriberAgreementDeclaration on ShopSubscriberAgreementDeclarationObject {
  id
  name
  label
  termsUrls
  agreed
}
    `;
export const ShopSubscriberRequirementFragmentDoc = gql`
    fragment ShopSubscriberRequirement on SubscriberRequirementObject {
  message
  isValid
  code
}
    `;
export const ShopSubscriberAgreementFragmentDoc = gql`
    fragment ShopSubscriberAgreement on ShopSubscriberAgreementObject {
  id
  name
  label
  termsUrls
  agreed
}
    `;
export const ShopSubscriberFragmentDoc = gql`
    fragment ShopSubscriber on ShopSubscriberObject {
  id
  state
  locale
  subscriptionId
  subscriptionName
  subscriptionSlug
  variantId
  variantName
  variantInterval
  variantChannel
  requirements {
    canSubscribe
    requirements {
      ...ShopSubscriberRequirement
    }
  }
  price {
    amount
    currency
  }
  shippingAddress {
    ...ShopAddress
  }
  billingAddress {
    ...ShopAddress
  }
  userPaymentMethod {
    id
    activatedAt
    expiresAt
    description
    publicAttributes
    isExpired
    state
  }
  requiredAgreements {
    ...ShopSubscriberAgreement
  }
}
    ${ShopSubscriberRequirementFragmentDoc}
${ShopAddressFragmentDoc}
${ShopSubscriberAgreementFragmentDoc}`;
export const ShopSubscriberDocument = gql`
    query ShopSubscriber($subscriberId: Int!) {
  shopSubscriber(subscriberId: $subscriberId) {
    ...ShopSubscriber
  }
}
    ${ShopSubscriberFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopSubscriberGQL extends Apollo.Query<ShopSubscriberQuery, ShopSubscriberQueryVariables> {
    document = ShopSubscriberDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopSubscribersDocument = gql`
    query ShopSubscribers($userId: Int!, $channelCode: String, $subscriptionId: Int) {
  shopSubscribers(
    userId: $userId
    channelCode: $channelCode
    subscriptionId: $subscriptionId
  ) {
    ...ShopSubscriber
  }
}
    ${ShopSubscriberFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopSubscribersGQL extends Apollo.Query<ShopSubscribersQuery, ShopSubscribersQueryVariables> {
    document = ShopSubscribersDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopCreateSubscriberDocument = gql`
    mutation ShopCreateSubscriber($input: ShopCreateSubscriberInput!) {
  shopCreateSubscriber(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopCreateSubscriberGQL extends Apollo.Mutation<ShopCreateSubscriberMutation, ShopCreateSubscriberMutationVariables> {
    document = ShopCreateSubscriberDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUpdateSubscriberPaymentMethodDocument = gql`
    mutation ShopUpdateSubscriberPaymentMethod($input: ShopUpdateSubscriberPaymentMethodInput!) {
  shopUpdateSubscriberPaymentMethod(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUpdateSubscriberPaymentMethodGQL extends Apollo.Mutation<ShopUpdateSubscriberPaymentMethodMutation, ShopUpdateSubscriberPaymentMethodMutationVariables> {
    document = ShopUpdateSubscriberPaymentMethodDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopUpdateSubscriberAddressDocument = gql`
    mutation ShopUpdateSubscriberAddress($input: ShopUpdateSubscriberAddressInput!) {
  shopUpdateSubscriberAddress(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopUpdateSubscriberAddressGQL extends Apollo.Mutation<ShopUpdateSubscriberAddressMutation, ShopUpdateSubscriberAddressMutationVariables> {
    document = ShopUpdateSubscriberAddressDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopActivateSubscriberDocument = gql`
    mutation ShopActivateSubscriber($input: ShopActivateSubscriberInput!) {
  shopActivateSubscriber(input: $input) {
    ...ShopSubscriber
  }
}
    ${ShopSubscriberFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopActivateSubscriberGQL extends Apollo.Mutation<ShopActivateSubscriberMutation, ShopActivateSubscriberMutationVariables> {
    document = ShopActivateSubscriberDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopPauseSubscriberDocument = gql`
    mutation ShopPauseSubscriber($input: ShopPauseSubscriberInput!) {
  shopPauseSubscriber(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopPauseSubscriberGQL extends Apollo.Mutation<ShopPauseSubscriberMutation, ShopPauseSubscriberMutationVariables> {
    document = ShopPauseSubscriberDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopSubscriberDeclarationDocument = gql`
    mutation ShopSubscriberDeclaration($input: ShopSubscriberDeclarationInput!) {
  shopSubscriberDeclaration(input: $input) {
    ...ShopSubscriberAgreementDeclaration
  }
}
    ${ShopSubscriberAgreementDeclarationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopSubscriberDeclarationGQL extends Apollo.Mutation<ShopSubscriberDeclarationMutation, ShopSubscriberDeclarationMutationVariables> {
    document = ShopSubscriberDeclarationDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }